import React, { useState, useEffect } from 'react';

interface AdminContainerProps {
    classList?: string;
    children: React.ReactNode;
}

export default function AdminContainer({ classList = ' ', children }: AdminContainerProps) {
    const [keyboardVisible, setKeyboardVisible] = useState(false);

    useEffect(() => {
        const initialViewportHeight = window.visualViewport?.height ?? 0;
        const handleResize = () => {
            if (window.visualViewport && window.visualViewport.height < initialViewportHeight) {
                setKeyboardVisible(true);
            } else {
                setKeyboardVisible(false);
            }
        };
        window.visualViewport?.addEventListener('resize', handleResize);
        return () => {
            window.visualViewport?.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div
            className={`relative mt-[70px] xl:mt-[100px] p-5 xl:p-10 max-w-[100dvw] ${classList}
                    flex flex-col grow
                    ${keyboardVisible ? 'pb-0' : 'pb-[env(safe-area-inset-bottom)]'} `}
        >
            {children}
        </div>
    );
}
